import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { clamp, isWeb, useWindowDimensions } from 'tamagui';

export const useMaxDynamicContentSize = (prop?: number) => {
  const { height } = useWindowDimensions();
  const { top } = useSafeAreaInsets();

  let value = height - top;

  if (isWeb) {
    value = height * 0.75;
  }

  if (prop) {
    value = clamp(prop, [prop, value]);
  }

  return value;
};
